export default __webpack_public_path__ + "static/media/Q03_濃郁流心熔岩的布朗尼.7ea841af.mp4";